<template>
  <div class="grid">
    <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color="#173EA3"
      :is-full-page="fullPage"
    ></loading>
    <div class="col-12">
      <div class="card">
        <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
        <Toast />
        <div class="p-fluid formgrid grid" style="margin-top: 2%">
          <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <InputText type="text" v-model="title"></InputText>
              <label for="name">Tittle</label>
            </span>
          </div>
          <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <Dropdown
                id="status"
                v-model="filter_selectstatus"
                :options="dropdownItems"
                :value="dropdownItems.value"
                optionLabel="name"
                filter
                
              >
              </Dropdown>
              <label for="status">Media Status</label>
            </span>
          </div>
          <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <Dropdown
                id="state"
                v-model="filter_selecttype"
                :options="type_dropdownItems"
                optionLabel="name"
                :value="type_dropdownItems.value"
                filter
                
              >
              <template #value="slotProps">
                <div v-if="slotProps.value" class="flex align-items-center">
                  
                    <div>{{ slotProps.value.group }} ( {{ slotProps.value.name }} )</div>
                </div>
              </template>
              <template #option="slotProps">
                <div class="flex align-items-center">
                 
                    <div>{{ slotProps.option.group }} ( {{ slotProps.option.name }} )</div>
                </div>
            </template>
              </Dropdown>
              <label for="type">Media Type</label>
            </span>
          </div>
          <div class="field col-12 md:col-2">
            <Button
              icon="pi pi-search"
              v-tooltip.bottom="'Search'"
              @click="search(1)"
            />
          </div>
        </div>
        <!-- <Toolbar class="mb-4">
          <template v-slot:start>
            <div class="my-2">
              <span class="p-float-label">
                <InputText v-model="title"> </InputText>
                <label>Tittle</label>
                &nbsp;
                <Button
                  icon="pi pi-search"
                  v-tooltip.bottom="'Search'"
                  @click="search(1)"
              /></span>
            </div>
          </template>
          <template v-slot:end> </template>
        </Toolbar> -->
        <!-- {{products}} -->
        <DataTable
          :loading="loading"
          ref="dt"
          :lazy="true"
          :totalRecords="totalRecords"
          :paginator="true"
          :value="products"
          v-model:selection="selectedProducts"
          :dataKey="columns[0]"
          :rows="limit"
          :filters="filters"
          @page="onPage($event)"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25, totalRecords]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          responsiveLayout="scroll"
          style="font-size: 12px"
          :rowHover="true"
          showGridlines
        >
          <template #empty>
            <b style="text-align: center">No records found.</b>
          </template>
          <template #header>
            <div
              class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
            >
              <h5 class="m-0"><b> Media Master</b></h5>
              <!-- Total Records:{{totalRecords}} -->
              <div>
                <Button
                  icon="pi pi-refresh"
                  @click="search(2)"
                  v-tooltip.bottom="'Refresh'"
                />&nbsp;
                <Button
                  icon="pi pi-plus"
                  v-tooltip.bottom="'Add'"
                  @click="openNew"
                />
              </div>
            </div>
            <div style="text-align: right; font-weight: bold">
              <span>Total Media:</span>{{ totalRecords }}
            </div>
          </template>
          <Column
            header="Status"
            style="min-width: 8rem; text-align: center"
            :field="columns[5]"
          >
            <template #body="{ data }">
              <span v-if="data.status == 'Active' || data.status == 'active'"
                ><badge :value="data.status" severity="success"></badge
              ></span>
              <span
                v-else-if="
                  data.status == 'InActive' || data.status == 'In Active'
                "
                ><badge :value="data.status" severity="warning"></badge
              ></span>
              <span
                v-else-if="data.status == 'Delete' || data.status == 'Deleted'"
                ><badge :value="data.status" severity="danger"></badge
              ></span>
              <span v-else>-</span>
            </template>
          </Column>
          <Column header="Sr No" style="min-width: 5rem; text-align: center">
            <template #body="{ index }">
              <span v-if="page_no == 1">{{ +index + +1 }}</span>
              <span v-else>{{ +index + 1 + limit * (page_no - 1) }}</span>
            </template>
          </Column>
          <Column header="Tittle" :field="columns[1]" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.title }}
            </template>
          </Column>
          <Column
            header="Subtitle"
            :field="columns[2]"
            style="min-width: 15rem"
          >
            <template #body="{ data }">
              {{ data.subtitle }}
            </template>
          </Column>
          <!-- <Column
            header="Description"
            :field="columns[4]"
            style="min-width: 5rem"
          >
          <template #body="{ data }">
              {{ data.description }}
            </template>
          </Column> -->
          <Column header="Type" :field="columns[4]" style="min-width: 5rem">
            <template #body="{ data }">
              <!-- {{ checktype(data.type_id) }} -->
              <span v-if="data.media_type && data.media_type[0]">{{
                data.media_type[0].name
              }}</span>
            </template>
          </Column>
          <Column header="Genre" :field="columns[4]" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.Genre }}
            </template>
          </Column>
          <Column header="Language" :field="columns[4]" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.Language }}
            </template>
          </Column>
          <Column
            header="Movie Length"
            :field="columns[4]"
            style="min-width: 10rem"
          >
            <template #body="{ data }">
              {{ data["Movie Length"] }}
            </template>
          </Column>
          <Column
            header="Release Date"
            :field="columns[4]"
            style="min-width: 10rem"
          >
            <template #body="{ data }">
              {{ data["Release Date"] }}
            </template>
          </Column>
          <Column header="Starring" :field="columns[4]" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data["Starring"] }}
            </template>
          </Column>
          <Column
            header="Unrestricted"
            :field="columns[4]"
            style="min-width: 5rem"
          >
            <template #body="{ data }">
              {{ data["Unrestricted"] }}
            </template>
          </Column>
          <Column header="Director" :field="columns[4]" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data["Director"] }}
            </template>
          </Column>
          <Column header="Action" headerStyle="min-width:10rem;">
            <template #body="slotProps">
              <Button
                icon="pi pi-pencil"
                class="p-button-rounded p-button-help mr-2"
                v-tooltip.bottom="'Edit'"
                @click="editProduct(slotProps.data)"
              />
              <Button
                icon="pi pi-trash"
                v-tooltip.bottom="'Delete'"
                class="p-button-rounded p-button-warning mt-2"
                @click="confirmDeleteProduct(slotProps.data)"
              />
            </template>
          </Column>
        </DataTable>
        <Sidebar
          v-model:visible="productDialog"
          header="Media Details"
          position="full"
          style="font-weight: bold; background-color: #f2f4f6"
        >
          <div class="col-12">
            <div class="p-fluid formgrid grid">
              <div class="field col-12 md:col-6" style="margin-top: 1%">
                <span class="p-float-label">
                  <InputText
                    id="title"
                    type="text"
                    v-model.trim="product.title"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.title }"
                  /><label for="title"><b>Tittle</b> </label>
                </span>
              </div>
              <div class="field col-12 md:col-6" style="margin-top: 1%">
                <span class="p-float-label">
                  <InputText
                    id="subtitle"
                    type="text"
                    v-model.trim="product.subtitle"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.subtitle }"
                  /><label for="subtitle"><b>Sub-Tittle</b></label>
                </span>
              </div>
              <div class="field col-12 md:col-12" style="margin-top: 1%">
                <span class="p-float-label">
                  <Textarea
                    id="description"
                    v-model.trim="product.description"
                    required="true"
                    autofocus
                    rows="6"
                    :class="{ 'p-invalid': submitted && !product.description }"
                  /><label for="description"><b>Description</b></label>
                </span>
              </div>
              <div class="field col-12 md:col-3" style="margin-top: 1%">
                <span class="p-float-label">
                  <Dropdown
                    id="status"
                    v-model="selectstatus"
                    :options="dropdownItems"
                    :value="dropdownItems.value"
                    optionLabel="name"
                    :class="{ 'p-invalid': submitted && !selectstatus }"
                    required="true"
                  ></Dropdown>
                  <label for="status"><b>Status</b></label>
                </span>
              </div>
              <div class="field col-12 md:col-3" style="margin-top: 1%">
                <span class="p-float-label">
                  <Dropdown
                    id="type"
                    v-model="selecttype"
                    :options="type_dropdownItems"
                    :value="type_dropdownItems.value"
                    optionLabel="name"
                    :class="{ 'p-invalid': submitted && !selecttype }"
                    required="true"
                    v-on:change="change_height_width"
                  >
                  <template #value="slotProps">
                    <div v-if="slotProps.value" class="flex align-items-center">
                      <div>{{ slotProps.value.group }} ( {{ slotProps.value.name }} )</div>
                    </div>
                  </template>
                  <template #option="slotProps">
                    <div class="flex align-items-center">
                      <div>{{ slotProps.option.group }} ( {{ slotProps.option.name }} )</div>
                    </div>
                  </template>
                  </Dropdown
                  ><label for="type"><b>Media Type</b></label>
                </span>
              </div>
              <div class="field col-12 md:col-3" style="margin-top: 1%">
                <span class="p-float-label">
                  <InputText
                    id="Genre"
                    type="text"
                    v-model.trim="product.Genre"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.Genre }"
                  /><label for="Genre"><b>Genre</b></label>
                </span>
              </div>
              <div class="field col-12 md:col-3" style="margin-top: 1%">
                <span class="p-float-label">
                  <InputText
                    id="Language"
                    type="text"
                    v-model.trim="product.Language"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.Language }"
                  /><label for="Language"><b>Language</b></label>
                </span>
              </div>
              <div class="field col-12 md:col-3" style="margin-top: 1%">
                <span class="p-float-label">
                  <!--<Calendar
                    id="calendar-timeonly"
                    v-model="product['Movie Length']"
                    timeOnly
                  />-->
                   <InputText
                    id="Movie_Length"
                    type="number"
                    v-model.trim="product['Movie Length']"
                    required="true"
                    autofocus
                    :class="{
                      'p-invalid': submitted && !product['Movie Length'],
                    }"
                  /> 
                  <label for="Movie_Length"><b>Movie Length ( Min )</b></label>
                </span>
              </div>
              <div class="field col-12 md:col-3" style="margin-top: 1%">
                <span class="p-float-label">
                  <Calendar
                   
                    view="year"
                    dateFormat="yy"
                    v-model="product['Release Date']"
                  ></Calendar>
                  <label for="Release_Date"><b>Release Date</b></label>
                </span>
              </div>
              <div class="field col-12 md:col-3" style="margin-top: 1%">
                <span class="p-float-label">
                  <InputText
                    id="Starring"
                    type="text"
                    v-model.trim="product['Starring']"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product['Starring'] }"
                  /><label for="Starring"><b>Starring</b></label>
                </span>
              </div>
              <div class="field col-12 md:col-3" style="margin-top: 1%">
                <span class="p-float-label">
                  <InputText
                    id="Unrestricted"
                    type="text"
                    v-model.trim="product['Unrestricted']"
                    required="true"
                    autofocus
                    :class="{
                      'p-invalid': submitted && !product['Unrestricted'],
                    }"
                  /><label for="Unrestricted"><b>Unrestricted</b></label>
                </span>
              </div>
              <div class="field col-12 md:col-3" style="margin-top: 1%">
                <span class="p-float-label">
                  <InputText
                    id="Director"
                    type="text"
                    v-model.trim="product['Director']"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product['Director'] }"
                  /><label for="Director"><b>Director</b></label>
                </span>
              </div>
              <div class="field col-12 md:col-3" style="margin-top: 1%">
                <span class="p-float-label">
                  <Dropdown
                    id="type"
                    v-model="media_dropdown_selected"
                    :options="media_dropdownItems"
                    :value="media_dropdownItems._id"
                    optionLabel="title"
                    required="true"
                    filter
                  ></Dropdown
                  ><label for="type"><b>Part Of</b></label>
                </span>
              </div>
              <div class="field col-12 md:col-3" style="margin-top: 1%">
                <span class="p-float-label">
                  <InputText
                    id="season"
                    type="text"
                    v-model.trim="product.season"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.season }"
                  /><label for="season"><b>Season</b></label>
                </span>
              </div>
              <div class="field col-12 md:col-3" style="margin-top: 1%"></div>
              <div class="field col-12 md:col-3" style="margin-top: 1%">
                <!-- <label for=""><b>Thumbnail</b> </label> -->
                <Button
                  label="Upload Thumbnail"
                  @click="toggleShow"
                  icon="pi pi-check"
                  class="p-button-primary"
                />
                <my-upload
                  field="img"
                  @crop-success="cropSuccess"
                  langType="en"
                  v-model="show_image"
                  :width="width"
                  :height="height"
                  :url="url"
                  :params="params"
                  :headers="headers"
                  img-format="png"
                  :noCircle="true"
                  :noRotate="false"
                >
                </my-upload>
              </div>
              <div class="field col-12 md:col-3">
                <Image :src="imgDataUrl" alt="Image" width="100" preview />
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="p-fluid formgrid grid">
              <div class="field col-12 md:col-12">
                <hr />
                Upload Section :-
              </div>
              <div class="field col-12 md:col-3">
                <label for=""><b>Low Video</b></label>
                <FileUpload
                  mode="basic"
                  name="model[]"
                  accept="video/*"
                  
                  :auto="true"
                  :custom-upload="true"
                  choose-label="Upload Low Video"
                  @uploader="handleFileUpload_low($event)"
                />
              </div>
              <div class="field col-12 md:col-3">
                <label for=""><b>Medium Video</b></label>
                <FileUpload
                  mode="basic"
                  name="model[]"
                  accept="video/*"
                  
                  :auto="true"
                  :custom-upload="true"
                  choose-label="Upload Medium Video"
                  @uploader="handleFileUpload_medium($event)"
                />
              </div>
              <div class="field col-12 md:col-3">
                <label for=""><b>Large Video</b></label>
                <FileUpload
                  mode="basic"
                  name="model[]"
                  accept="video/*"
                  
                  :auto="true"
                  :custom-upload="true"
                  choose-label="Upload Large Video"
                  @uploader="handleFileUpload_large($event)"
                />
              </div>
              <div class="field col-12 md:col-3">
                <label for=""><b>Extra Large Video</b></label>
                <FileUpload
                  mode="basic"
                  name="model[]"
                  accept="video/*"
                  
                  :auto="true"
                  :custom-upload="true"
                  choose-label="Upload Extra Large Video"
                  @uploader="handleFileUpload_extra_large($event)"
                />
              </div>
              <div class="field col-12 md:col-3">
                <video width="350" height="240" controls :key="LOW">
                  <source
                   
                    :src="LOW"
                    
                  />
                </video>
              </div>
              <div class="field col-12 md:col-3">
                <video width="350" height="240" controls :key="MEDIUM">
                  <source
                    
                    :src="MEDIUM"
                    
                  />
                </video>
              </div>
              <div class="field col-12 md:col-3">
                <video width="350" height="240" controls :key="LARGE">
                  <source
                    
                    :src="LARGE"
                    
                  />
                </video>
              </div>
              <div class="field col-12 md:col-3">
                <video width="350" height="240" controls :key="EXTRA_LARGE">
                  <source
                   
                    :src="EXTRA_LARGE"
                   
                  />
                </video>
              </div>
              <div class="field col-12 md:col-10"></div>
              <div class="field col-12 md:col-2">
                <Button
                  v-if="product._id"
                  label="Update"
                  @click="add_update_media"
                  icon="pi pi-check"
                  class="p-button-warning"
                />
                <Button
                  v-else
                  label="Submit"
                  @click="add_update_media"
                  icon="pi pi-check"
                  class="p-button-warning"
                />
              </div>
            </div>
          </div>
          <!-- <div class="col-12">
            <Button
              v-if="product._id"
              label="Update"
              @click="add_update_media"
              icon="pi pi-check"
              class="p-button-warning"
            />
            <Button
              v-else
              label="add"
              @click="add_update_media"
              icon="pi pi-check"
              class="p-button-warning"
            />
          </div> -->
        </Sidebar>
        <!-- 
-----------------------------------------------------------------------------------------------------------   -->
        <Dialog
          v-model:visible="deleteProductDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem"
            />
            <span v-if="product"
              >Are you sure you want to delete <b>{{ product.title }}</b
              >?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteProductDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteuser"
            />
          </template>
        </Dialog>
        <Dialog
          v-model:visible="deleteProductsDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem"
            />
            <span v-if="product"
              >Are you sure you want to delete the selected products?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteProductsDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteSelectedProducts"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>
  <script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import JsonExcel from "vue-json-excel";
import BreadcrumbService from "../service/BreadcrumbService";
//import FormNewsMaster from "@/components/FormNewsMaster";
//import * as Survey from "survey-vue";
// import axios from "axios";
import apis from "@/apis";
import axios from "axios";
import { log } from "util";
import myUpload from "vue-image-crop-upload";
export default {
  data() {
    return {
      media_dropdownItems:[],
      media_dropdown_selected:"",
      width: 250,
      height: 300,
      show_image: false,
      params: {
        token: "123456798",
        name: "avatar",
      },
      headers: {
        smail: "*_~",
      },
      imgDataUrl: "", // the datebase64 url of created image
      LOW: "",
      MEDIUM: "",
      LARGE: "",
      EXTRA_LARGE: "",
      Thumbnail_data: {
        filePath: "",
        contentType: "",
      },
      Low_data: {
        filePath: "",
        contentType: "",
      },
      Medium_data: {
        filePath: "",
        contentType: "",
      },
      Large_data: {
        filePath: "",
        contentType: "",
      },
      Extra_Large_data: {
        filePath: "",
        contentType: "",
      },
      type_dropdownItems: [],
      selecttype: "",
      filter_selecttype: "",
      filter_selectstatus: "",
      place_details: "",
      end_place_details: "",
      searchme: "",
      name: "",
      page_no: 1,
      isLoading: false,
      isLoadingModel: false,
      loading: false,
      fullPage: true,
      file_attachment: "",
      icon_dropdown: [],
      title: "",
      dropdownItems: [
        { name: "Active", value: "Active" },
        { name: "InActive", value: "InActive" },
        { name: "Deleted", value: "Deleted" },
      ],
      parent_dropdownItems: [],
      selectstatus: { name: "", value: "" },
      parent_selectstatus: { name: "", value: "" },
      pick_icon: { name: "", value: "" },
      products: null,
      productDialog: false,
      deleteProductDialog: false,
      deleteProductsDialog: false,
      lazyParams: {},
      product: {},
      selectedProducts: null,
      filters: {},
      offset: 1,
      // selectstatus2: { name: "Motivational", value: "Motivational" },
      limit: 10,
      columns: [],
      head: [
        "Data Usages",
        "Network Connectivity",
        "Students",
        "Teachers",
        "Student Registration",
        "News Master",
        "Government Panel",
        "Feedback Master",
        "User Queries",
        "Schemes Master",
        "Notice Master",
        "Subject Master",
        "Teacher Schedule Master",
        "Teacher Schedule DE Master",
        "Query Types Master",
        "Sub Query Types Master",
        "Admin Users",
        "Application Roles",
        "Departments",
        "Cast Master",
        "Year Master",
        "District Master",
        "Student Attendance",
        "Student Document",
        "Teachers",
        "Radical ids",
        "Subject Topics",
        "Query Comments",
        "Student Submit Answers",
        "Mock Tests",
        "Mock Test Papers",
        "Mock Test Results",
        "Video",
        "Syllabus",
        "Course",
      ],
      pageno: 1,
      submitted: false,
      icons: null,
      totalRecords: 0,
      id: "",
      statuses: [
        { label: "INSTOCK", value: "instock" },
        { label: "LOWSTOCK", value: "lowstock" },
        { label: "OUTOFSTOCK", value: "outofstock" },
      ],
      BreadcrumbService: null,
      breadcrumbHome: {},
      breadcrumbItems: [],
      url: "",
    };
  },
  productService: null,
  async created() {
    this.productService = new ProductService();
    this.initFilters();
    this.BreadcrumbService = new BreadcrumbService();
    let Breadcrum_data = this.BreadcrumbService.mediamaster();
    this.breadcrumbHome = Breadcrum_data.home;
    this.breadcrumbItems = Breadcrum_data.items;
    this.get_media_type();
    await this.get_media();
  },
  async mounted() {
    // this.productService.getProducts().then(data => this.products = data);
    this.id = this.$route.params.id;
    this.lazyParams = {
      first: 0,
      rows: this.limit,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (this.totalRecords == 0) {
      await this.get_count();
    }
    await this.get_list();
    //alert(this.id);
  },
  watch: {
    async $route() {
      this.products = [];
      this.columns = [];
      this.totalRecords = 0;
      this.id = this.$route.params.id;
      if (this.id) {
        await this.get_count();
        this.get_list();
      }
    },
  },
  methods: {
    async change_height_width() {
      //alert(this.selecttype.name)
      if (this.selecttype.name == "Banner") {
        this.width = 840;
        this.height = 720;
      } else {
        this.width = 214;
        this.height = 287;
      }
    },
    toggleShow() {
      this.show_image = !this.show_image;
    },
    async cropSuccess(imgDataUrl) {
      this.imgDataUrl = imgDataUrl;
      var substrings = imgDataUrl.split(";");
      var contentType = substrings[0].split(":");
      var type = imgDataUrl.split(";")[0].split("/")[1];
      this.handleFileUpload_thumb_with_cropper(
        imgDataUrl,
        type,
        contentType[0]
      );
    },
    cropUploadSuccess(jsonData, field) {
      console.log("-------- upload success --------");
      console.log(jsonData);
      console.log("field: " + field);
    },
    cropUploadFail(status, field) {
      console.log("-------- upload fail --------");
      console.log(status);
      console.log("field: " + field);
    },
    async formatter(parameter) {
      var data = new Date(parameter);
      const hours = data.getHours();
      const minutes = data.getMinutes();
      // Format the hours and minutes with leading zeros if needed
      const formattedHours = hours < 10 ? `0${hours}` : hours;
      const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
      // Concatenate the formatted time
      const formattedTime = `${formattedHours}:${formattedMinutes}`;
      return formattedTime;
    },
    async replaceSpacesWithUnderscores(inputString) {
      // Use the replace function with a regular expression to replace all spaces with underscores
      var temp = inputString.replace(/ /g, "_");
      //remove last part like .png or .jpeg
      var match = temp.match(/^(.*)\.([^.]+)$/);
      return {
        beforeDot: match[1], // Part before the last dot
        removedPart: "." + match[2], // Removed part (file extension with dot)
      };
    },
    async reset_upload() {
      this.LOW="";
      this.MEDIUM="";
      this.LARGE="";
      this.EXTRA_LARGE="";

      this.imgDataUrl="";
      this.Thumbnail_data = {
        filePath: "",
        contentType: "",
      };
      this.Low_data = {
        filePath: "",
        contentType: "",
      };
      this.Medium_data = {
        filePath: "",
        contentType: "",
      };
      this.Large_data = {
        filePath: "",
        contentType: "",
      };
      this.Extra_Large_data = {
        filePath: "",
        contentType: "",
      };
      this.media_dropdown_selected = "";
    },
    async check_tittle_and_type() {
      if (
        this.product.title == "" ||
        this.selecttype == "" ||
        this.selecttype.name == ""
      ) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Please select media tittle and media type",
          life: 3000,
        });
        return 1;
      }
    },
    async handleFileChange(base64, content_Type, filename) {
      const base64String = base64;
      const contentType = content_Type;
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: contentType });
      const fileName = filename;
      var file = new File([blob], fileName, { type: contentType });
      return file;
    },
    async handleFileUpload_thumb_with_cropper(imgDataUrl, type, contentType) {
      var check = await this.check_tittle_and_type();
      if (check == 1) {
        return false;
      }

      var prfeix= await this.generateString();
      var filename = "Thumbnail_"+prfeix + "." + type;

      //var filename = this.product.title + "." + type;
      var subimgDataUrl = imgDataUrl.split(",");
      var file = await this.handleFileChange(
        subimgDataUrl[1],
        contentType,
        filename
      );
      this.Thumbnail_data = {
        filePath: "",
        contentType: "",
      };
      this.Thumbnail_data = {
        filePath:
          "Entertainment/" +
          this.selecttype.name +
          "/" +
          this.product.title +
          "/" +
          filename,
        contentType: contentType,
      };
      this.isLoadingModel = true;
      var promise = apis.upload_to_AWS(this.Thumbnail_data);
      promise.then((response) => {
        axios
          .put(response.data.data, file, {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": contentType,
            },
          })
          .then((response) => {
            this.isLoadingModel = false;
            this.$toast.add({
              severity: "success",
              summary: "success",
              detail: "Upload Successfully",
              life: 3000,
            });
            return false;
          });
      });
    },
    async handleFileUpload_thumb_aws(event) {
      var check = await this.check_tittle_and_type();
      if (check == 1) {
        return false;
      }
      const fileUp = event.files[0];
      var file = fileUp;
      var modifiedString = await this.replaceSpacesWithUnderscores(file.name);
      //var filename = modifiedString.beforeDot + "_" + file.type + modifiedString.removedPart;
      var filename = modifiedString.beforeDot + modifiedString.removedPart;
      this.Thumbnail_data = {
        filePath: "",
        contentType: "",
      };
      this.Thumbnail_data = {
        //filePath:file.name,
        filePath:
          "Entertainment/" +
          this.selecttype.name +
          "/" +
          this.product.title +
          "/" +
          filename,
        contentType: file.type,
      };
      //upload to aws
      var promise = apis.upload_to_AWS(this.Thumbnail_data);
      promise.then((response) => {
        axios
          .put(response.data.data, file, {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": file.type,
            },
          })
          .then((response) => {
            this.$toast.add({
              severity: "success",
              summary: "success",
              detail: "Upload Successfully",
              life: 3000,
            });
            return false;
          });
      });
    },

    async generateString() {
  // Get the current date and time
  const currentDateTime = new Date();

  // Format the date as YYYY_MM_DD
  const formattedDate = currentDateTime.toISOString().split('T')[0].replace(/-/g, '_');

  // Format the time as HH_mm_ss
  const formattedTime = currentDateTime.toTimeString().split(' ')[0].replace(/:/g, '_');

  // Construct the final string
  const resultString = `${formattedDate}_${formattedTime}`;

  return resultString;
},

    async handleFileUpload_low(event) {
      var check = await this.check_tittle_and_type();
      if (check == 1) {
        return false;
      }
      console.log("event", event);
      console.log("event.files[0]", event.files[0]);
      var fileUp = event.files[0];
      var file = fileUp;
      var modifiedString = await this.replaceSpacesWithUnderscores(file.name);
      
      //var filename = "LOW_"+modifiedString.beforeDot + modifiedString.removedPart;
      var prfeix= await this.generateString();
      var filename = "LOW_"+prfeix;

      this.Low_data = {
        filePath: "",
        contentType: "",
      };
      this.Low_data = {
        //filePath:file.name,
        filePath:
          "Entertainment/" +
          this.selecttype.name +
          "/" +
          this.product.title +
          "/" +
          filename,
        contentType: file.type,
      };
      this.isLoadingModel = true;
      //upload to aws
      var promise = apis.upload_to_AWS(this.Low_data);
      promise.then((response) => {
        
        axios
          .put(response.data.data, file, {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": file.type,
            },
          })
          .then((response) => {
            this.isLoadingModel = false;
            this.$toast.add({
              severity: "success",
              summary: "success",
              detail: "Upload Successfully",
              life: 3000,
            });
            this.LOW =
              "https://travelsafe-docs.s3.ap-south-1.amazonaws.com/" +
              this.Low_data.filePath;
          });
      });
    },
    async handleFileUpload_medium(event) {
      var check = await this.check_tittle_and_type();
      if (check == 1) {
        return false;
      }
      var fileUp = event.files[0];
      var file = fileUp;
      var modifiedString = await this.replaceSpacesWithUnderscores(file.name);
      //var filename = modifiedString+"_"+file.type+".jpg";
      //var filename =modifiedString.beforeDot + "_" + file.type + modifiedString.removedPart;
      //var filename = "MEDIUM_"+modifiedString.beforeDot + modifiedString.removedPart;
      var prfeix= await this.generateString();
      var filename = "MEDIUM_"+prfeix;
      this.Medium_data = {
        filePath: "",
        contentType: "",
      };
      this.Medium_data = {
        //filePath:file.name,
        filePath:
          "Entertainment/" +
          this.selecttype.name +
          "/" +
          this.product.title +
          "/" +
          filename,
        contentType: file.type,
      };
      this.isLoadingModel = true;
      //upload to aws
      var promise = apis.upload_to_AWS(this.Medium_data);
      promise.then((response) => {
        
        axios
          .put(response.data.data, file, {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": file.type,
            },
          })
          .then((response) => {
            this.isLoadingModel = false;
            this.$toast.add({
              severity: "success",
              summary: "success",
              detail: "Upload Successfully",
              life: 3000,
            });
            this.MEDIUM =
              "https://travelsafe-docs.s3.ap-south-1.amazonaws.com/" +
              this.Medium_data.filePath;
          });
      });
    },
    async handleFileUpload_large(event) {
      var check = await this.check_tittle_and_type();
      if (check == 1) {
        return false;
      }
      var fileUp = event.files[0];
      var file = fileUp;
      var modifiedString = await this.replaceSpacesWithUnderscores(file.name);
      //var filename = modifiedString+"_"+file.type+".jpg";
      // var filename =modifiedString.beforeDot + "_" + file.type + modifiedString.removedPart;
      //var filename = "LARGE_" + modifiedString.beforeDot + modifiedString.removedPart;

      var prfeix= await this.generateString();
      var filename = "LARGE_"+prfeix;
      this.Large_data = {
        filePath: "",
        contentType: "",
      };
      this.Large_data = {
        //filePath:file.name,
        filePath:
          "Entertainment/" +
          this.selecttype.name +
          "/" +
          this.product.title +
          "/" +
          filename,
        contentType: file.type,
      };
      this.isLoadingModel = true;
      //upload to aws
      var promise = apis.upload_to_AWS(this.Large_data);
      promise.then((response) => {
       
        axios
          .put(response.data.data, file, {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": file.type,
            },
          })
          .then((response) => {
            this.isLoadingModel = false;
            this.$toast.add({
              severity: "success",
              summary: "success",
              detail: "Upload Successfully",
              life: 3000,
            });
            this.LARGE =
              "https://travelsafe-docs.s3.ap-south-1.amazonaws.com/" +
              this.Large_data.filePath;
          });
      });
    },
    async handleFileUpload_extra_large(event) {
      var check = await this.check_tittle_and_type();
      if (check == 1) {
        return false;
      }
      var fileUp = event.files[0];
      var file = fileUp;
      var modifiedString = await this.replaceSpacesWithUnderscores(file.name);
      //var filename = modifiedString+"_"+file.type+".jpg";
      //var filename =modifiedString.beforeDot + "_" + file.type + modifiedString.removedPart;
      //var filename = "EXTRA_LARGE_"+modifiedString.beforeDot + modifiedString.removedPart;

      var prfeix= await this.generateString();
      var filename = "EXTRA_LARGE_"+prfeix;
      this.Extra_Large_data = {
        filePath: "",
        contentType: "",
      };
      this.Extra_Large_data = {
        //filePath:file.name,
        filePath:
          "Entertainment/" +
          this.selecttype.name +
          "/" +
          this.product.title +
          "/" +
          filename,
        contentType: file.type,
      };
      this.isLoadingModel = true;
      //upload to aws
      var promise = apis.upload_to_AWS(this.Extra_Large_data);
      promise.then((response) => {
        
        axios
          .put(response.data.data, file, {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": file.type,
            },
          })
          .then((response) => {
            this.isLoadingModel = false;
            this.$toast.add({
              severity: "success",
              summary: "success",
              detail: "Upload Successfully",
              life: 3000,
            });
            this.EXTRA_LARGE =
              "https://travelsafe-docs.s3.ap-south-1.amazonaws.com/" +
              this.Extra_Large_data.filePath;
          });
      });
    },
    async search(count) {
      if (count == 2) {
        this.title = "";
        this.filter_selectstatus = "";
        this.filter_selecttype = "";
      }
      await this.get_list();
      await this.get_count();
    },
    async editProduct(product) {
      await this.reset_upload();
      this.file_attachment = "";
      this.product = { ...product };
      this.productDialog = true;
      if (this.product.parent_movie_id) 
      {
        this.media_dropdown_selected = { title: "", _id: "" };
        this.media_dropdown_selected._id = this.product.parent_movie_id;
        this.media_dropdown_selected.title = this.product.parent_movie_name;
      }
      if (this.product.status) {
        this.selectstatus = { name: "", value: "" };
        this.selectstatus.value = this.product.status;
        this.selectstatus.name = this.product.status;
      }
      if (this.product["type_id"]) {
        this.selecttype = { name: "", value: "" };
        this.selecttype = await this.findById(
          this.type_dropdownItems,
          this.product["type_id"]
        );
        await this.change_height_width();
      }
      if (this.product["Release Date"]) {
        this.product["Release Date"] = new Date(this.product["Release Date"]);
      }
      
      if (this.product["thumb"] != "") {
        this.imgDataUrl = this.product["thumb"];
      }
      
      this.LOW = this.product.video_link.LOW;
      this.MEDIUM = this.product.video_link.MEDIUM;
      this.LARGE = this.product.video_link.LARGE;
      this.EXTRA_LARGE = this.product.video_link.EXTRA_LARGE;
    },
    async findById(jsonArray, targetId) {
      // Use the find function to get the first object with the specified id
      const result = jsonArray.find((item) => item._id === targetId);
      return result;
    },
    isNumber(evt) {
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      }
    },
    async onPage(event) {
      this.lazyParams = event;
      this.page_no = event.page + 1;
      this.limit = event.rows;
      if (this.totalRecords > 0) {
        this.get_list();
      }
    },
    get_count: function () {
      // var type='';
      // if(this.user_type_search!='')
      // {
      //   type=this.user_type_search.code;
      // }
      var data = {
        count: true,
        title: this.title,
        type_id: this.filter_selectstatus,
        status: this.filter_selecttype,
        type_id: this.filter_selecttype != "" ? this.filter_selecttype._id : "",
        status:
          this.filter_selectstatus != "" ? this.filter_selectstatus.name : "",
      };
      this.loading = true;
      var promise = apis.getMediaList(data);
      promise.then((response) => {
        this.loading = false;
        //   console.log(response);
        this.totalRecords = response.data.data;
        //alert(this.totalRecords);
      });
      // console.log(data);
    },
    get_list: function () {
      // var type='';
      // if(this.user_type_search!='')
      // {
      //   type=this.user_type_search.code;
      // }
      var data = {
        limit: this.limit,
        page_no: this.page_no,
        count: false,
        title: this.title,
        type_id: this.filter_selecttype != "" ? this.filter_selecttype._id : "",
        status:
          this.filter_selectstatus != "" ? this.filter_selectstatus.name : "",
      };
      this.loading = true;
      var promise = apis.getMediaList(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.products = response.data.data;
        console.log(this.products[0]);
        if (this.columns.length == 0) {
          if (this.products.length > 0) {
            this.columns = Object.keys(this.products[0]);
          }
        }
        this.parent_dropdownItems = [];
        for (let a = 0; a < response.data.data.length; a++) {
          this.parent_dropdownItems.push({
            name: response.data.data[a].title,
            value: response.data.data[a]._id,
          });
        }
      });
      console.log(data);
    },
    async get_media()
    {
        var data = {};
        var promise = apis.Get_Media(data);
        promise.then((response) => {
          this.media_dropdownItems = response.data.data;
        });
    },
    async get_media_type() {
      var data = {};
      var promise = apis.getMediaType(data);
      promise.then((response) => {
        console.log(response.data.data);
        this.type_dropdownItems = response.data.data;
      });
    },
    formatCurrency(value) {
      if (value)
        return value.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        });
      return;
    },
    async openNew() {
      this.product = {};
      this.submitted = false;
      this.selectstatus = "";
      this.selecttype = "";
      await this.reset_upload();
      this.productDialog = true;
    },
    hideDialog() {
      this.productDialog = false;
      this.submitted = false;
    },
    async getYearFromDate(dateString) {
      const dateObject = new Date(dateString);
      const year = dateObject.getFullYear();
      console.log("🚀 ~ getYearFromDate ~ year:", year)
      
      return year.toString();
    },
    async add_update_media() {
      this.submitted = true;
      if (!this.product["Release Date"]) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Select Release Year",
          life: 3000,
        });
        return false;
      }
      //edit
      if (this.product._id) {
        var thumb = this.product.thumb;
        if (this.Thumbnail_data.filePath != "") {
          thumb =encodeURI("https://travelsafe-docs.s3.ap-south-1.amazonaws.com/" +this.Thumbnail_data.filePath);
        }
        var video_link = {};

        if (this.Low_data.filePath != "") {
         
          video_link["LOW"] =encodeURI("https://travelsafe-docs.s3.ap-south-1.amazonaws.com/" +this.Low_data.filePath);
        } else {
         
          video_link["LOW"] = this.product.video_link["LOW"];
        }


        if (this.Medium_data.filePath != "") {
          
          video_link["MEDIUM"] =encodeURI("https://travelsafe-docs.s3.ap-south-1.amazonaws.com/" +this.Medium_data.filePath);
        } else {
         
          video_link["MEDIUM"] = this.product.video_link["MEDIUM"];
        }



        if (this.Large_data.filePath != "") {
          
          video_link["LARGE"] =encodeURI("https://travelsafe-docs.s3.ap-south-1.amazonaws.com/" +this.Large_data.filePath);
        } else {
         
          video_link["LARGE"] = this.product.video_link["LARGE"];
        }


        if (this.Extra_Large_data.filePath != "") {
          video_link["EXTRA_LARGE"] =encodeURI("https://travelsafe-docs.s3.ap-south-1.amazonaws.com/" +this.Extra_Large_data.filePath);
        } else {
          video_link["EXTRA_LARGE"] = this.product.video_link["EXTRA_LARGE"];
        }
        var movies_length = "";
      
          movies_length = this.product["Movie Length"];
       
        var year = await this.getYearFromDate(this.product["Release Date"]);
        var data = {
          _id: this.product._id,
          title: this.product.title,
          subtitle: this.product.subtitle,
          description: this.product.description,
          thumb: thumb,
          video_link: video_link,
          type_id: this.selecttype._id,
          sequence_number: this.selecttype.sequence_number,
          Genre: this.product.Genre,
          season: this.product.season,
          status: this.selectstatus.value,
          Language: this.product.Language,
          "Movie Length": movies_length,
          "Release Date": year,
          Starring: this.product.Starring,
          Unrestricted: this.product.Unrestricted,
          Director: this.product.Director,
          updated_at: "",
          updated_by: localStorage.getItem("id"),
          parent_movie_id: this.media_dropdown_selected._id,
          parent_movie_name: this.media_dropdown_selected.title
        };
        this.isLoadingModel = true;
        var promise = apis.EditMedia(data);
        promise
          .then((responseapi) => {
            this.$swal(responseapi.data.message);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.get_list();
            this.get_count();
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.$swal.fire(error.response.data);
            this.get_list();
            this.get_count();
          });
      }
      //add-----------------------------------------------------------------------------------------------------------------
      else {
        if (this.Thumbnail_data.filePath=='') {
          this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Please Upload Thumbnail",
          life: 3000,
        });
        return false;
        }
        if (this.Low_data.filePath=='') {
          this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Please Upload Low Video",
          life: 3000,
        });
        return false;
        }
        if (this.Medium_data.filePath=='') {
          this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Please Upload Medium Video",
          life: 3000,
        });
        return false;
        }
        if (this.Large_data.filePath=='') {
          this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Please Upload Large Video",
          life: 3000,
        });
        return false;
        }
        if (this.Extra_Large_data.filePath=='') {
          this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Please Upload Extra Large Video",
          life: 3000,
        });
        return false;
        }
        var thumb                 = encodeURI("https://travelsafe-docs.s3.ap-south-1.amazonaws.com/" +this.Thumbnail_data.filePath);
        var video_link            = {};
        video_link["LOW"]         =encodeURI("https://travelsafe-docs.s3.ap-south-1.amazonaws.com/" +this.Low_data.filePath);
        video_link["MEDIUM"]      =encodeURI("https://travelsafe-docs.s3.ap-south-1.amazonaws.com/" +this.Medium_data.filePath);
        video_link["LARGE"]       =encodeURI("https://travelsafe-docs.s3.ap-south-1.amazonaws.com/" +this.Large_data.filePath);
        video_link["EXTRA_LARGE"] =encodeURI("https://travelsafe-docs.s3.ap-south-1.amazonaws.com/" +this.Extra_Large_data.filePath);
       
        var movies_length = "";
       
          movies_length =this.product["Movie Length"];
  
        var year = await this.getYearFromDate(this.product["Release Date"]);
        var data1 = {
          title: this.product.title,
          subtitle: this.product.subtitle,
          description: this.product.description,
          thumb: thumb,
          video_link: video_link,
          type_id: this.selecttype._id,
          sequence_number: this.selecttype.sequence_number,
          Genre: this.product.Genre,
          season: this.product.season,
          status: this.selectstatus.value,
          Language: this.product.Language,
          "Movie Length": movies_length,
          "Release Date": year,
          Starring: this.product.Starring,
          Unrestricted: this.product.Unrestricted,
          Director: this.product.Director,
          created_by: localStorage.getItem("id"),
          parent_movie_id: this.media_dropdown_selected._id,
          parent_movie_name: this.media_dropdown_selected.title
        };
        this.isLoadingModel = true;
        var promises = apis.AddMedia(data1);
        promises
          .then((response) => {
            this.isLoadingModel = false;
            this.productDialog = false;
            this.reset_upload();
            this.$swal(response.data.message);
            this.get_list();
            this.get_count();
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.$swal.fire(error.response.data);
            this.get_list();
            this.get_count();
          });
      }
    },
    confirmDeleteProduct(product) {
      this.product = product;
      this.deleteProductDialog = true;
    },
    deleteProduct() {
      this.products = this.products.filter((val) => val.id !== this.product.id);
      this.deleteProductDialog = false;
      this.product = {};
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Product Deleted",
        life: 3000,
      });
    },
    deleteuser() {
      if (this.product._id) {
        var data = {
          _id: this.product._id,
          updated_by: localStorage.getItem("id"),
        };
        this.isLoadingModel = true;
        var promise = apis.DeleteMedia(data);
        promise.then((responseapi) => {
          this.isLoadingModel = false;
          if (responseapi.data.status == true) {
            // this.hideDialog1();
            this.deleteProductDialog = false;
            this.$swal(responseapi.data.message);
            this.get_list();
            this.get_count();
          } else {
            this.$swal("error to Delete Media");
          }
        });
      }
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },
    createId() {
      let id = "";
      var chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        id += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return id;
    },
    async exportCSV() {
      this.limit = this.totalRecords;
      this.get_list();
      await this.$refs.dt.exportCSV();
    },
    confirmDeleteSelected() {
      this.deleteProductsDialog = true;
    },
    deleteSelectedProducts() {
      this.products = this.products.filter(
        (val) => !this.selectedProducts.includes(val)
      );
      this.deleteProductsDialog = false;
      this.selectedProducts = null;
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Products Deleted",
        life: 3000,
      });
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
  components: { downloadExcel: JsonExcel, "my-upload": myUpload },
};
</script>
  <style scoped lang="scss">
@import "../assets/demo/badges.scss";
@import "../assets/demo/documentation.scss";
.icons-list {
  i {
    color: var(--text-color-secondary);
  }
}
</style>
  